import { createFileRoute } from '@tanstack/react-router'
import { BarChart3 } from 'lucide-react'

import { LotStatsPage } from '@/components/warehouse/lot-stats-page'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/purchase-lots/stats',
)({
    component: () => (
        <LotStatsPage
            kind="purchase"
            title={m.nav_purchase_stats()}
            subtitle={m.lot_stats_subtitle()}
            permission="purchase_lots.read"
            icon={BarChart3}
            groupDimLabel={m.lot_stats_dim_grade()}
        />
    ),
})
